<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester ssystem college department sclass keyword="學號、學生姓名">
                </query>
                <btn-group :load="reload" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>班級</th>
                            <th>學號-學生姓名</th>
                            <th>性別</th>
                            <th>出生日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.StudentNo">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.StudentNo" /></td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.StudentNo)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="性別">{{item.Sex|sex}}</td>
                        <td data-th="出生日期">{{item.Birthday|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload"></Detail>
    </page-main>
</template>

<script>
    import Detail from './studataDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'studata',
        api: '/api/studata/',
        components: { Detail }
    });
</script>

<style>
</style>